<ng-container [formGroup]="formGroup">
  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Nom</mat-label>
      <input matInput formControlName="name" placeholder="Ex. Apicil" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Adresse</mat-label>
      <input matInput formControlName="address" placeholder="Ex. 38 rue François Peissel" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Adresse complémentaire</mat-label>
      <input matInput formControlName="additionalAddress" placeholder="Ex. BP 118" />
    </mat-form-field>
  </div>
  <div class="flex gap">
    <mat-form-field class="w-100">
      <mat-label>Code postal</mat-label>
      <input matInput formControlName="postalCode" placeholder="Ex. 69644" />
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Ville</mat-label>
      <input
        matInput
        formControlName="city"
        placeholder="Ex. CALUIRE et CUIRE CEDEX"
        appToUppercase
      />
    </mat-form-field>
  </div>
</ng-container>
